import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
import React, { Component } from 'react'
import JSON from 'json5'

export class MapContainer extends Component {
  state = {
    //showingInfoWindow: false,
  }

  componentDidMount(){
    this.interval = setInterval(() => this.tick(), 250);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  registerMap = (mapProps, map) => {
    this.setState({
      map: map
    });
  }

  tick = () =>{
    //console.log("tick: " + (this.state.answer !== undefined) + " " + (this.props.otherMarker !== undefined));
    
    if(this.props.mapSearch !== undefined){
      //console.log(this.props.mapSearch);
      if(this.state.oldSearch !== undefined){
        if(this.state.oldSearch.lat !== this.props.mapSearch.lat || this.state.oldSearch.lng !== this.props.mapSearch.lng){
          this.searchChanged();
        }
      }else{
        this.searchChanged();
      }
      
    }

    if(this.state.answer !== undefined){
      if(this.state.oldAnswer !== undefined){
        if(this.state.oldAnswer.lat !== this.state.answer.lat || this.state.oldAnswer.lng !== this.state.answer.lng){
          this.answerChanged();
        }
      }else{
        this.answerChanged();
      }
    }

    if(this.props.otherMarker !== undefined){
      if(this.state.oldOther !== undefined){
        if(this.state.oldOther.lat !== this.props.otherMarker.lat || this.state.oldOther.lng !== this.props.otherMarker.lng){
          this.otherChanged();
        }
      }else{
        this.otherChanged();
      }
    }
  }

  answerChanged = () => {
    //console.log("answer changed?");
    this.setState({
      oldAnswer: this.state.answer
    });

    this.state.map.panTo(this.state.answer);
    //console.log(this.props.google.maps.MapTypeId.TERRAIN);//.map.panTo(this.state.answer);
    
  }

  searchChanged = () => {
    console.log("search changed");
    this.setState({
      oldSearch: this.props.mapSearch,
      answer: this.props.mapSearch
    });
    
    this.props.stateUpdatingCallback({answer: this.state.answer})

    this.state.map.panTo(this.props.mapSearch);
  }

  otherChanged = () => {
    //console.log("other changed?");

    this.setState({
      oldOther: this.props.otherMarker
    });

    this.state.map.panTo(this.props.otherMarker);
  }

  onClick = (t, map, coord) => {
    const { latLng } = coord;
    this.setState({
      answer: {lat: latLng.lat(),lng: latLng.lng()},
    })
    
    this.props.stateUpdatingCallback({answer: this.state.answer})
    //map.panTo(this.props.otherMarker);
  }

  drawOtherMarker = () =>{
    
    if(this.props.otherMarker !== undefined){
      //console.log(this.props.otherMarker);
      return(
              <Marker
                  title = "other marker" 
                  position={this.props.otherMarker}
                  icon = {{url: this.props.otherPin, scaledSize: {width: 80, height: 80}}}
                  clickable = {false}
                  >
              </Marker>
    );
    }else{
      //console.log("not defined marker in " + this.props.pinSymbol);
    }
  }

  render() {

    return (
      <Map
        google={this.props.google}
        zoom={14}
        styles={JSON.parse(this.props.mapStyles)}
        initialCenter={this.props.position}
        streetViewControl = {false}
        zoomControl = {false}
        mapTypeControl = {false}
        mapTypeId = {this.props.google.maps.MapTypeId.TERRAIN}
       
        fullscreenControl = {false}
        draggable = {true}
        onReady={this.registerMap}
        onClick = {this.onClick}>

          <Marker
              title={this.props.markerName} 
              position={this.state.answer}
              icon = {{url: this.props.pinSymbol, scaledSize: {width: 80, height: 80}}}
              clickable = {false}
              visible = {this.state.answer !== undefined}
              >
          </Marker>
        
        {this.drawOtherMarker()}

      </Map>
    );
  }
}
 
export default GoogleApiWrapper({
  apiKey: ('AIzaSyBHf8biKDHdRafH47yQnZEKwhsAnwNbGqE')
})(MapContainer)